import { createSelector } from '@ngrx/store';
import { getOneClickState } from '../reducers';

export const getOnePurchaseOrderState = createSelector(
  getOneClickState,
  state => state.purchaseOrderState,
);

export const getOneValidatedPurchaseOrder = createSelector(
  getOnePurchaseOrderState,
  state => state.validated,
);
